export default __webpack_public_path__ + "static/media/Insurance.7f34ab08.png";